import withTabSwitcherMobile from './withTabSwitcherMobile';

export default withTabSwitcherMobile;
